import { defineStore } from 'pinia'
import { actions, getters, state } from './ext/items.js'
import axios from 'axios'

export const useTeamsStore = defineStore('teams', {
  id: 'teams',
  state: () => ({
    items: [],
    api: '/api/v1/teams'
  }),
  getters: {
    ...getters,
    getItemsByFundraiserId: (state) => (fundraiserId) => state.items.filter(item => item.fundraiser_id === fundraiserId),
  },
  actions: {
    ...actions,
    async fetchTeamMembersByTeamId(teamId) {
      const { data } = await axios.get(`${this.api}/${teamId}/members`)
      return data
    },
    async removeTeamMember(teamId, fundraiserPageId) {
      const { data } = await axios.delete(`${this.api}/${teamId}/members/${fundraiserPageId}`)
      return data
    },
    async addTeamMember(teamId, fundraiserPageId) {
      const { data } = await axios.post(`${this.api}/${teamId}/members`,{
        fundraiser_page_id: fundraiserPageId
      })
      return data
    }
  }
})
